<template>

  <main class="ps-page--my-account">
    <div class="ps-breadcrumb">
      <div class="container">
        <ul class="breadcrumb">
            <li v-if="isEnglish()==true"><a href="/#/private">Home</a></li>
            <li v-if="isEnglish()==false"><a href="/#/private">Acceuil</a></li>
            <li v-if="isEnglish()==true" >User Information</li>
            <li v-if="isEnglish()==false" >Informations de l'utilisateur</li>
          </ul>
      </div>
    </div>
    <section class="ps-section--account">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="ps-section__left">
              <aside class="ps-widget--account-dashboard">
                <div class="ps-widget__header"><img src="../assets/img/users/3.jpg" alt="">
                  <figure>
                    <figcaption>Hello</figcaption>
                    <p><a href="#">{{user_email}}</a></p>
                  </figure>
                </div>
                  <side-menu :lang="lang" :recip_state="recip_state"></side-menu>
              </aside>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="ps-section__right">
              <section class="ps-items-listing">
                <div v-if="isEnglish()==true" class="ps-section__actions">
                  <a v-on:click="openNewRecipientWindow()" class="ps-btn success" href="#" data-toggle="modal" data-target="#newModal">
                    <i class="icon icon-plus mr-2"></i>New Recipient</a>
                </div>
                 <div v-if="isEnglish()==false" class="ps-section__actions">
                  <a v-on:click="openNewRecipientWindow()" class="ps-btn success" href="#" data-toggle="modal" data-target="#newModal">
                    <i class="icon icon-plus mr-2"></i>Nouveau destinataire</a>
                </div>
                <br/>
                <!--<div class="ps-section__header">
                </div>-->
                <div class="ps-section__content">
                  <div class="table-responsive">
                    <div v-if="sent" class="alert alert-success" role="alert">
                      {{msg}}
                    </div>

                    <table class="table ps-table" id="myTable">
                    <thead>
                    <tr>
                        <th v-if="isEnglish()==true">Full name</th>
                        <th v-if="isEnglish()==false">Nom complet</th>
                        <th>Contact</th>
                        <th>Email</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="recipient in recipients" :key="recipient.id">
                        <td><a href="#"><strong>{{recipient.full_name}}</strong></a></td>
                        <td>{{recipient.contact}}</td>
                        <td>{{recipient.email}}</td>

                    <td>
                        <div class="dropdown"><a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="icon-ellipsis"></i></a>
                            <div v-if="isEnglish()==true" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a  class="dropdown-item" v-on:click="greet(recipient)" data-toggle="modal" data-target="#updateModal" href="#">Update</a>
                              <a class="dropdown-item" v-on:click="greet(recipient)" data-toggle="modal" data-target="#deleteModal" href="#">Delete</a>
                            </div>
                            <div v-if="isEnglish()==false" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a  class="dropdown-item" v-on:click="greet(recipient)" data-toggle="modal" data-target="#updateModal" href="#">Modifier</a>
                              <a class="dropdown-item" v-on:click="greet(recipient)" data-toggle="modal" data-target="#deleteModal" href="#">Supprimer</a>
                            </div>
                        </div>
                    </td>
                    </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

              </section>
            </div>
          </div>
        </div>
      </div>
    </section>


    <div class="modal fade" id="newModal" tabindex="-1" role="dialog" aria-labelledby="newModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isEnglish()==true" class="modal-title" id="inviteModalLabel">Create new recipient</h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="inviteModalLabel">Créer nouveau destinataire</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>

            <div class="row form-group">
                <div class="col">
                    <div  v-if="failed" class="alert alert-danger" role="alert">
                      {{ msg }}
                    </div>
                    <label v-if="isEnglish()==true">Full name <sup>*</sup> </label>
                     <label v-if="isEnglish()==false">Nom complet <sup>*</sup> </label>
                    <input type="text" v-model="new_recipient.full_name" class="form-control" required maxlength="32">
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Contact number<sup>*</sup>    </label>
                 <label v-if="isEnglish()==false">Numero de contact<sup>*</sup>    </label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.contact" required>
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Phone extension</label>
                <label v-if="isEnglish()==false">Numéro de poste</label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.phoneext" maxlength="20">
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Address<sup>*</sup>    </label>
                 <label v-if="isEnglish()==false">Adresse<sup>*</sup>    </label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.address" required maxlength="46">
                </div>
            </div>

            <div class="form-group">
                 <label v-if="isEnglish()==true">Address 2<sup></sup>    </label>
                 <label v-if="isEnglish()==false">Adresse 2<sup></sup>    </label>

                    <div class="form-group__content">
                        <input class="form-control" type="text" v-model="new_recipient.address2" maxlength="25">
                    </div>
            </div>

            <div class="form-group">
                <label>Email<sup>*</sup>
                </label>
                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.email" required>
                </div>
            </div>

              <div class="form-group">
                    <label v-if="isEnglish()==true">Company<sup></sup>    </label>
                    <label v-if="isEnglish()==false">Compagnie<sup></sup>    </label>

                    <div class="form-group__content">
                        <input class="form-control" type="text" v-model="new_recipient.company" maxlength="30">
                    </div>
             </div>






                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">City<sup>*</sup>    </label>
                                        <label v-if="isEnglish()==false">Ville<sup>*</sup>    </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.city" required maxlength="30">
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select country<sup>*</sup></label>
                                        <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Selectionnez pays<sup>*</sup></label>
                                        <select class="form-control"  @change="onCountrySelect(new_recipient.country)" v-model="new_recipient.country" required>
                                            <option v-if="isEnglish()==true" value="" >Select a country</option>
                                            <option v-if="isEnglish()==false" value="" >Choisissez un pays</option>
                                            <option  v-for="country in countries" :key="country.code" v-bind:value="country.code">  {{country.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select region<sup>*</sup></label>
                                        <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Selectionnez région<sup>*</sup></label>
                                        <select class="form-control" v-model="new_recipient.region" required>
                                            <option v-if="isEnglish()==true" value="" >Select a region</option>
                                            <option v-if="isEnglish()==false" value="" >Choisir une région</option>
                                            <option  v-for="region in regions" :key="region.region" v-bind:value="region.name">  {{region.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEnglish()==true"> Postal code<sup>*</sup>    </label>
                                        <label v-if="isEnglish()==false"> Code Postal <sup>*</sup>    </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.postal_code" required maxlength="30">
                                        </div>
                                    </div>


            </form>
          </div>
          <div class="modal-footer">
            <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button v-if="isEnglish()==true" type="button" class="btn btn-primary" v-on:click="create_new_recipient()">Create Recipient</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-primary" v-on:click="create_new_recipient()">Créer destinataire</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="updateModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isEnglish()==true" class="modal-title" id="changeroleModalLabel">Update a recipient</h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="changeroleModalLabel">Editer un destinataire</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>

            <div class="row form-group">
                <div class="col">
                    <div  v-if="failed" class="alert alert-danger" role="alert">
                      {{ msg }}
                    </div>
                    <label v-if="isEnglish()==true">Full name<sup>*</sup></label>
                    <label v-if="isEnglish()==false">Nom complet<sup>*</sup></label>
                    <input type="text" v-model="new_recipient.full_name" class="form-control" required maxlength="32">
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Contact number<sup>*</sup>    </label>
                <label v-if="isEnglish()==false">Numero de contact<sup>*</sup>    </label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.contact" required>
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Phone extension</label>
                <label v-if="isEnglish()==false">Numéro de poste</label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.phoneext" maxlength="20">
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Address<sup>*</sup> </label>
                <label v-if="isEnglish()==false">Adresse<sup>*</sup></label>
                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.address" required maxlength="46">
                </div>
            </div>

            <div class="form-group">
                <label>Email<sup>*</sup>
                </label>
                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.email" required>
                </div>
            </div>


              <div class="form-group">
                                        <label v-if="isEnglish()==true">Company<sup></sup>    </label>
                                         <label v-if="isEnglish()==false">Compagnie<sup></sup>     </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.company" maxlength="30">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">City<sup>*</sup>     </label>
                                        <label v-if="isEnglish()==false">Ville<sup>*</sup>     </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.city" required maxlength="30">
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select country<sup>*</sup></label>
                                        <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir pays<sup>*</sup></label>
                                        <select class="form-control"  @change="onCountrySelect(new_recipient.country)" v-model="new_recipient.country" required>
                                            <option v-if="isEnglish()==true" value="" >Select a country</option>
                                            <option v-if="isEnglish()==false" value="" >Choisir un pays</option>
                                            <option  v-for="country in countries" :key="country.code" v-bind:value="country.code">  {{country.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select region<sup>*</sup></label>
                                        <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir une région<sup>*</sup></label>
                                        <select class="form-control" v-model="new_recipient.region" required>
                                            <option v-if="isEnglish()==true" value="" >Select a region</option>
                                            <option v-if="isEnglish()==false" value="" > Choisir une région</option>
                                            <option  v-for="region in regions" :key="region.region" v-bind:value="region.name">  {{region.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEnglish()==true">Postal code<sup>*</sup>     </label>
                                        <label v-if="isEnglish()==false">Code Postal <sup>*</sup>     </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.postal_code" required maxlength="30">
                                        </div>
                                    </div>

            </form>
          </div>
          <div v-if="isEnglish()==true" class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" v-on:click="update_recipient()">Apply</button>
          </div>
          <div v-if="isEnglish()==false" class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button type="button" class="btn btn-primary" v-on:click="update_recipient()">Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isEnglish()==true" class="modal-title" id="deleteModalLabel">Are you sure you want to delete {{new_recipient.full_name}} ?</h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="deleteModalLabel">Etes vous sure de vouloir supprimer {{new_recipient.full_name}} ?</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>

            <div class="row form-group">
                <div class="col">
                    <div  v-if="failed" class="alert alert-danger" role="alert">
                        {{ msg }}
                    </div>
                    <label v-if="isEnglish()==true">Full name</label>
                    <label v-if="isEnglish()==false">Nom complet</label>
                    <input type="text" v-model="new_recipient.full_name" class="form-control" disabled>
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Contact number<sup>*</sup>    </label>
                <label v-if="isEnglish()==false">Numero de contact<sup>*</sup>    </label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.contact" disabled>
                </div>
            </div>

            <div class="form-group">
                <label v-if="isEnglish()==true">Address<sup>*</sup>    </label>
                <label v-if="isEnglish()==false">Adresse<sup>*</sup>    </label>

                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.address" disabled>
                </div>
            </div>

            <div class="form-group">
                <label>Email<sup>*</sup>
                </label>
                <div class="form-group__content">
                <input class="form-control" type="text" v-model="new_recipient.email" disabled>
                </div>
            </div>

            </form>
          </div>
          <div v-if="isEnglish()==true" class="modal-footer">
            <button  type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="delete_recipient()">Yes</button>
          </div>
           <div v-if="isEnglish()==false" class="modal-footer">
            <button  type="button" class="btn btn-secondary" data-dismiss="modal">Non</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="delete_recipient()">Oui</button>
          </div>
        </div>
      </div>
    </div>



  </main>
</template>


<script>
import DataService from "@/services/DataService";
import SideMenu from './SideMenu.vue';


export default {
  name: 'Recipients',
  components: {
    'side-menu': SideMenu
  },
  props: ['search_on','search_obj','language'],
  data () {
    return {
      recip_state:"active",
      msg: 'Welcome to Your Vue.js App',
      recipients:[],
      user_email: localStorage.getItem('email'),
      failed:false,
      sent: false,
      lang : this.language,
      noRecord:false,
      caller_role:localStorage.getItem('caller_role'),
      token:localStorage.getItem('token'),
      new_recipient:{id:"",full_name:"",contact:"",phoneext:"",address:"",email:"",company:"",address2:"",city:"",country:"",region:"",postal_code:""},
      countries:{},
      regions:{}
    }
  },

    methods: {

    greet: function (item) {
        this.failed=false,
        this.new_recipient = item;
        console.log(item);
        this.list_regions(item.country);

    },

    openNewRecipientWindow(){
     this.failed = false;
     this.new_recipient = {id:"",full_name:"",contact:"",phoneext:"",address:"",email:"",company:"",address2:"",city:"",country:"",region:"",postal_code:""};

    },

    list_recipients(){

        this.noRecord = false;
        var token = localStorage.getItem('token');
        console.log(token);
        var dataa = {};
        DataService.get_recipients(dataa,token)
          .then(response => {

            console.log(response);
            this.recipients = response.data.recipients;
             setTimeout(() => $('#myTable').DataTable(), 1000);
            if(this.recipients.length==0){
              this.msg = 'No recipients available ';
              this.noRecord = true;
            }

          })
          .catch(e => {
            console.log(e.response);
            //this.message = error.response.data.errors[0];

          if(e!=undefined){

           if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }

          });
    },

    create_new_recipient(){
        this.sent = false;this.failed = false;
        var dataa = this.new_recipient;
        console.log(dataa);
        var token = localStorage.getItem('token');
        DataService.create_recipient(dataa,token)
          .then(response => {
            console.log(response.data);
            this.msg = this.$parent.translate_error_message(response.data,"message");

           this.list_recipients();
            $('#newModal').modal('hide');
            this.sent = true;

          }).catch(e => {
            console.log(e.response);
            this.sent = false;

            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }
               this.$parent.eventmsg = this.msg;
              this.$parent.showeventmsg = false;
              this.$parent.showerrormsg = true;
              setTimeout(() => this.$parent.showerrormsg = false, 3000);
            this.failed = true;
          });
    },

    update_recipient(){
        this.sent = false;this.failed = false;
        var dataa = this.new_recipient;
        console.log(dataa);
        var token = localStorage.getItem('token');
        DataService.update_recipient(dataa,token)
          .then(response => {
            console.log(response.data);
            this.msg = this.$parent.translate_error_message(response.data,"message");
            $('#updateModal').modal('hide');
            this.sent = true;

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){
              this.msg = "Route nod found";
              this.failed = true;
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
              this.failed = true;
            }else if(e.response.status == 422){
              this.msg = e.response.data.errors[0];
              this.failed = true;
            }else {
              this.msg = "Please check your internet.";
              this.failed = true;
            }

          });
    },

    delete_recipient(){

        this.sent = false;this.failed = false;
        var dataa = this.new_recipient;
        console.log(dataa);
        var token = localStorage.getItem('token');
        DataService.delete_recipient(dataa,token)
          .then(response => {

            console.log(response.data);

            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.sent = true;
            this.list_recipients();

          })
          .catch(error => {
            console.log(error.response);
            this.failed = true;
          });
    },

     onCountrySelect(country){

       console.log(country);

       this.list_regions(country);
    },

    list_countries(){


        var token = localStorage.getItem('token');
        console.log(token);
        var dataa = {};
        DataService.get_countries(dataa,token)
          .then(response => {
            console.log(response);
            this.countries = response.data.countries;


          })
          .catch(e => {
            console.log(e.response);

          if(e!=undefined){

           if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }

          });
    },

    list_regions(country){


        var token = localStorage.getItem('token');
        console.log(token);
        var dataa = {country:country};
        DataService.get_regions(dataa,token)
          .then(response => {
            console.log(response);
            this.regions = response.data.regions;


          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];

          });
    },

    isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

    },



    },

    watch: {

    search_on:function(){
        console.log("value of search_on is :"+this.search_on);


        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }

        console.log(this.search_obj);
    },

    language:function(){
        this.lang = this.language;


        console.log("language value has changed in private component");
        //this.language = this.lang ;
    },

},







    created(){

      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');

      }else{


          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          this.list_countries();


      }
    },



    mounted(){

         this.list_recipients();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Recipients.vue